export default __webpack_public_path__ + "resources/icons/n422-4f63.png";